export default "__VITE_ASSET__CrcFbM1z__"